export const validateSegment = "editor/segments/worker/VALIDATE_SEGMENT";
export const convertPatternToTilemapIndexes = "editor/segments/worker/CONVERT_PATTERN_TO_TILEMAP_INDEXES";
